import { cn } from '@/lib/utils'

const cardVariants = {
  default: 'bg-panel border border-line rounded-2xl shadow-sm',
  elevated: 'bg-panel rounded-2xl shadow-lg',
  interactive:
    'bg-panel border border-line rounded-2xl shadow-sm hover:shadow-md hover:border-line-strong hover:-translate-y-0.5 transition-all duration-200 cursor-pointer',
  gradient:
    'bg-gradient-to-br from-brand-green-soft to-brand-violet-soft rounded-2xl border border-brand-green-line',
}

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: keyof typeof cardVariants
}

export function Card({
  className,
  variant = 'default',
  ...props
}: CardProps) {
  return <div className={cn(cardVariants[variant], className)} {...props} />
}

export function CardHeader({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 pb-0', className)} {...props} />
}

export function CardContent({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6', className)} {...props} />
}

export function CardFooter({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 pt-0', className)} {...props} />
}
